export default __webpack_public_path__ + "static/media/hermit-screenshot.1f555f22.png";